<template>
	<sf-data-table
		:columns="columns"
		:rows="rows"
		selection
		index
		:excel="isButton_(scrId, 'EX')"
		@selection-change="onSelectionChange"
		paging
		:pageUnit="pageUnit_"
		:pageArray="screen.pageArray"
		:totalSize="totalSize_"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'AD')" size="lg" line icon="square-plus" :onClick="addRow">{{
				getMessage_('SWCC000326')
			}}</sf-button>
			<sf-button
				v-if="isButton_(scrId, 'CU')"
				size="lg"
				line
				icon="file"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000555'),
							buttons: [{ title: getMessage_('SWCC000327'), clickFn: modifyTasks }]
						})
				"
				>{{ getMessage_('SWCC000327') }}</sf-button
			>
			<sf-button
				v-if="isButton_(scrId, 'CD')"
				size="lg"
				color="error"
				line
				icon="trash"
				:onClick="
					() =>
						$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: getMessage_('SWCC000554'),
							buttons: [{ title: getMessage_('SWCC000328'), clickFn: removeTasks }]
						})
				"
				>{{ getMessage_('SWCC000328') }}</sf-button
			>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TaskManagement/store/helpers';
import * as yup from 'yup';
import { utils } from '@sfaas/util';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {},
			useYns: [
				{ label: 'Y', value: 'Y' },
				{ label: 'N', value: 'N' }
			],
			cdKinds: [
				{ label: 'java', value: 'java' },
				{ label: 'csharp', value: 'csharp' }
			],
			taskTypes: [
				{ label: '일반', value: 'CT' },
				{ label: '전역 변수', value: 'GV' },
				{ label: '전역 함수', value: 'GF' }
			]
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000329'),
					prop: 'taskId',
					minWidth: '250px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000330'),
					prop: 'version',
					width: '100px'
				},
				{
					label: this.getMessage_('SWCC000331'),
					prop: 'taskName',
					minWidth: '250px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000902'),
					prop: 'taskType',
					minWidth: '100px',
					form: {
						type: 'select',
						options: this.taskTypes
					}
				},
				{
					label: this.getMessage_('SWCC000893'),
					prop: 'cdKind',
					width: '100px',
					form: {
						type: 'select',
						options: this.cdKinds
					}
				},
				{
					label: this.getMessage_('SWCC000332'),
					prop: 'link',
					minWidth: '100px',
					clickEvent: this.openTaskScriptModal,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000335'),
					prop: 'taskDesc',
					minWidth: '250px'
				},
				{
					label: this.getMessage_('SWCC000336'),
					prop: 'useYn',
					minWidth: '100px',
					form: {
						type: 'select',
						options: this.useYns
					}
				},
				{
					label: this.getMessage_('SWCC000724'),
					prop: 'namespace',
					minWidth: '250px'
				},
				{
					label: this.getMessage_('SWCC000725'),
					prop: 'className',
					minWidth: '250px'
				},
				{
					label: this.getMessage_('SWCC000848'),
					prop: 'regId',
					minWidth: '150px'
				},
				{
					label: this.getMessage_('SWCC000849'),
					prop: 'regDt',
					minWidth: '150px'
				}
			];
		},
		rows() {
			return this.tasks;
		},
		schema() {
			return yup.array().of(
				yup.object().shape({
					cdKind: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000893')])),
					taskType: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000902')])),
					taskId: yup
						.string()
						.test('max', this.getMessage_('SWCC000808'), value => !(this.getBytes(value) > 100))
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000329')])),
					taskName: yup
						.string()
						.test('max', this.getMessage_('SWCC000807'), value => !(this.getBytes(value) > 100))
						.nullable(),
					version: yup.number().nullable().required(this.getMessage_('SWCC000505')),
					namespace: yup
						.string()
						.test('max', this.getMessage_('SWCC000810'), value => !(this.getBytes(value) > 200))
						.nullable(),
					className: yup
						.string()
						.test('max', this.getMessage_('SWCC000809'), value => !(this.getBytes(value) > 200))
						.nullable()
				})
			);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		openTaskScriptModal(row) {
			this.DEFAULT_ASSIGN({ key: 'taskScriptModal', value: true });
			this.setScriptValue(row);
		},
		setScriptValue(row) {
			this.DEFAULT_ASSIGN({ key: 'scriptParams', value: row });
			this.$sf_toggleLoading(true);
			this.fetchTaskScript_({
				plantCd: this.user.plantCd,
				taskId: this.scriptParams.taskId,
				version: this.scriptParams.version
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		excelFunc() {
			const url = `${BASE_URL}/task/v1/plants/${this.user.plantCd}/tasks`;
			const params = { url, columns: this.columns };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},

		changedPage({ currentPageVal, pageUnitVal }) {
			Promise.resolve()
				.then(() =>
					this.DEFAULT_ASSIGN({ key: 'pagingInfo', value: { ...this.pagingInfo, currentPage: currentPageVal, pageUnit: pageUnitVal } })
				)
				.then(this.findAllTasks);
		},
		onChange({ key, value, slotProps }) {
			const { index } = slotProps;
			const clonedTasks = this.tasks.slice();
			clonedTasks.splice(index, 1, { ...clonedTasks[index], [key]: value });
			this.DEFAULT_ASSIGN({
				key: 'tasks',
				value: clonedTasks
			});
		},
		onSelectionChange(selection) {
			this.DEFAULT_ASSIGN({
				key: 'selectedRows',
				value: selection
			});
		},
		addRow() {
			const tasks = this.tasks.slice();
			tasks.unshift({ version: '1', useYn: 'Y' });
			this.DEFAULT_ASSIGN({
				key: 'tasks',
				value: tasks
			});
		},
		async modifyTasks() {
			try {
				this.schema.validateSync(this.selectedRows);

				this.$sf_toggleLoading(true);
				await this.saveTasks_({ selectedRows: this.selectedRows, plantCd: this.user.plantCd })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchTasks_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async removeTasks() {
			try {
				this.schema.validateSync(this.selectedRows);

				this.$sf_toggleLoading(true);
				await this.deleteTasks_({ selectedRows: this.selectedRows })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchTasks_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		findAllTasks() {
			this.$sf_toggleLoading(true);
			this.fetchTasks_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }).finally(() => this.$sf_toggleLoading(false));
		}
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
		this.findAllTasks();
	}
};
</script>

<style langType="scss"></style>
